module.exports = __webpack_public_path__ + "img/touch_and_go.2642f14a.png";